module.exports = __webpack_public_path__ + "img/check-bordered.5342d148.svg";